module.exports = __webpack_public_path__ + "static/media/logo.f4a6edf5.png";